import type { EVENT_VARIABLE_TYPE, IndependentAction, NodeFieldContent } from '@lighthouse/core'
import type { FlowNode, SettingRecordFields } from '@lighthouse/shared'
import React from 'react'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSource } from '@/hooks/useDataSource'

import { SettingFieldValue } from '../SettingFieldValue'

export interface SettingRecordContentProps {
    value: NodeFieldContent[]
    dataSourceId: string
    upstreamNodes?: FlowNode[]
    allParentNodes?: FlowNode[]
    allParentActions?: IndependentAction[]
    disablePageLink?: boolean
    disableFormOption?: boolean
    disableViewOption?: boolean
    disablePageOption?: boolean
    disableInputOption?: boolean
    eventType?: EVENT_VARIABLE_TYPE
    onChange: (value: NodeFieldContent[]) => void
}

export const SettingRecordContent: React.FC<SettingRecordContentProps> = ({
    value,
    dataSourceId,
    upstreamNodes,
    allParentNodes,
    allParentActions,
    disablePageLink,
    disableFormOption,
    disableViewOption,
    disablePageOption,
    disableInputOption,
    eventType,
    onChange
}) => {
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()
    // const { data: personOptions } = useDataSourceUsers()
    const dataSource = useDataSource(appId, envId, dataSourceId)

    if (!dataSource) {
        return null
    }

    return (
        <SettingFieldValue
            appId={appId}
            envId={envId}
            value={value}
            onChange={onChange}
            upstreamNodes={upstreamNodes}
            allParentNodes={allParentNodes}
            allParentActions={allParentActions}
            dataSource={dataSource}
            disablePageLink={disablePageLink}
            disableFormOption={disableFormOption}
            disableViewOption={disableViewOption}
            disablePageOption={disablePageOption}
            disableInputOption={disableInputOption}
            eventType={eventType}
        />
    )
}
